// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__18R__","title":"Images90_title__2bY2c","images":"Images90_images__3u-QI"};